export const SoldDataPathType = {
  Root: '/sold-data',
  SendShareSoldDataEmail: '/sendShareSoldDataEmail',
  Search: '/search',
};

export default {
  SoldDataPathType,
};
